/**
 * Produkt Spotlight Slider
 * DSS - DeSight Shopify Theme
 */

import { $, $$, debounce } from '../utils/helpers.js';

class ProduktSpotlightSlider {
  constructor(containerId) {
    this.containerId = containerId;
    this.slider = $(`.produkt-spotlight__slider--${containerId}`);
    this.track = this.slider?.querySelector('.produkt-spotlight__slider-track');
    this.cards = this.slider ? Array.from(this.slider.querySelectorAll('.produkt-spotlight__product-card')) : [];
    this.prevBtn = $(`[data-slider-prev="${containerId}"]`);
    this.nextBtn = $(`[data-slider-next="${containerId}"]`);
    this.pagination = $(`[data-slider-pagination="${containerId}"]`);
    this.dots = this.pagination ? Array.from(this.pagination.querySelectorAll('.produkt-spotlight__pagination-dot')) : [];
    
    this.currentIndex = 0;
    this.cardsPerView = 1;
    this.maxIndex = 0;
    this.cardWidth = 0;
    this.padding = 16;
    
    if (!this.slider || !this.track || !this.cards.length) return;
    
    this.init();
  }

  init() {
    this.calculateDimensions();
    this.bindEvents();
    this.updateButtons();
    this.updatePagination();
    
    window.addEventListener('resize', debounce(() => this.calculateDimensions(), 150));
  }

  calculateDimensions() {
    const containerWidth = this.slider.offsetWidth;

    if (window.innerWidth >= 750) {
      this.cardsPerView = 2;
    } else {
      this.cardsPerView = 1;
    }

    const availableWidth = containerWidth - (this.padding * 2);
    const cardWidth = availableWidth / this.cardsPerView;
    this.cardWidth = cardWidth;

    this.cards.forEach(card => {
      card.style.flex = `0 0 ${cardWidth}px`;
      card.style.minWidth = `${cardWidth}px`;
    });

    this.maxIndex = Math.max(0, this.cards.length - this.cardsPerView);

    if (this.currentIndex > this.maxIndex) {
      this.currentIndex = this.maxIndex;
    }

    this.updatePosition();
    this.updateButtons();
    this.updatePagination();
  }

  updatePosition() {
    const offset = this.currentIndex * this.cardWidth;
    this.track.style.transform = `translateX(-${offset}px)`;
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }

  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  goToSlide(index) {
    if (index >= 0 && index <= this.maxIndex) {
      this.currentIndex = index;
      this.updatePosition();
      this.updateButtons();
      this.updatePagination();
    }
  }

  updateButtons() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }

  updatePagination() {
    if (!this.dots.length) return;
    
    this.dots.forEach((dot, index) => {
      if (index >= this.currentIndex && index < this.currentIndex + this.cardsPerView) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }
}

function initProduktSpotlightSliders() {
  const sliders = $$('[data-slider-id]');
  
  sliders.forEach(slider => {
    const id = slider.dataset.sliderId;
    if (id) {
      new ProduktSpotlightSlider(id);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProduktSpotlightSliders);
} else {
  initProduktSpotlightSliders();
}

document.addEventListener('shopify:section:load', initProduktSpotlightSliders);

export { ProduktSpotlightSlider, initProduktSpotlightSliders };
